
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { ListChecks } from 'lucide-react';
import { RestaurantDetails } from './details/RestaurantDetails';
import { HotelDetails } from './details/HotelDetails';
import { ActivityDetails } from './details/ActivityDetails';
import { FestivalDetails } from './details/FestivalDetails';
import { AdditionalInformation } from './details/AdditionalInformation';

interface PlaceDetailsProps {
  place: any;
  isEditing: boolean;
  onInputChange: (field: string, value: any) => void;
}

export function PlaceDetails({ place, isEditing, onInputChange }: PlaceDetailsProps) {
  // Function to render details based on place type
  const renderPlaceTypeDetails = () => {
    switch (place.place_type) {
      case 'restaurant':
        return <RestaurantDetails place={place} isEditing={isEditing} onInputChange={onInputChange} />;
      case 'hotel':
        return <HotelDetails place={place} isEditing={isEditing} onInputChange={onInputChange} />;
      case 'hiking_trail':
      case 'adventure_activity':
      case 'tour':
        return <ActivityDetails place={place} isEditing={isEditing} onInputChange={onInputChange} />;
      case 'festival':
        return <FestivalDetails place={place} isEditing={isEditing} onInputChange={onInputChange} />;
      default:
        return null;
    }
  };

  return (
    <Card className="mt-8">
      <CardContent className="p-6">
        <div className="space-y-8">
          {/* Common Details Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold flex items-center gap-2">
              <ListChecks className="w-5 h-5" />
              General Information
            </h3>

            {place.note && (
              <div className="prose dark:prose-invert max-w-none">
                <p>{place.note}</p>
              </div>
            )}

            {/* Display specific details based on place type */}
            {renderPlaceTypeDetails()}
          </div>

          {/* Common Additional Information */}
          <AdditionalInformation place={place} />
        </div>
      </CardContent>
    </Card>
  );
}
